import { FC, useRef } from 'react';

import { getSelectedProfessions } from 'utils/profRoles';

import { Text, TextTypography, TooltipHover } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import {
    CAMPAIGNS_TABLE_COLUMNS_MAP,
    CampaignsTableColumn,
} from 'components/CampaignsDashboard/components/CampaignsTable/columns';
import { MobileEllipsisText } from 'components/CampaignsDashboard/components/CampaignsTable/components/MobileEllipsisText';
import { CELL_TYPOGRAPHY, MOBILE_CELL_TYPOGRAPHY } from 'components/CampaignsDashboard/utils/constants';

import { selectProfessions } from 'store/autoReducers';
import { useSelector } from 'store/utils';

interface CampaignProfessionsProps {
    professionalRoles: string[];
    isMobile?: boolean;
    typography?: TextTypography;
}

export const CampaignProfessions: FC<CampaignProfessionsProps> = ({
    professionalRoles,
    isMobile = false,
    typography: typographyOverride,
}) => {
    const professions = useSelector((state) => selectProfessions(state));

    const trls = useTrls();
    const activatorRef = useRef<HTMLDivElement>(null);
    const typography = typographyOverride ?? (isMobile ? MOBILE_CELL_TYPOGRAPHY : CELL_TYPOGRAPHY);

    const [, allProfessions] = getSelectedProfessions(professions, professionalRoles);
    const professionNames = allProfessions.map((item) => item.name).join(', ');

    if (isMobile) {
        return (
            <MobileEllipsisText
                typography={typography}
                bottomSheetTitle={trls(CAMPAIGNS_TABLE_COLUMNS_MAP[CampaignsTableColumn.ProfessionalRoles].trlKey)}
                dataQa="campaign-professions-full-content"
            >
                {professionNames}
            </MobileEllipsisText>
        );
    }

    return (
        <>
            <Text maxLines={3} typography={typography}>
                <span ref={activatorRef}>{professionNames}</span>
            </Text>
            <TooltipHover delay={1000} activatorRef={activatorRef} placement="top-center">
                {professionNames}
            </TooltipHover>
        </>
    );
};
